<template>
<div v-if="!loading">
    <!-- <transition-group tag="div" name="list"> -->
    <component
    v-for="(item,index) in galleryContent"
    :is="item.acf_fc_layout"
    :data="item"
      :key="index"
      :isDownloadable="wpData.is_content_downloadable"
      :position="index"/>
  <!-- </transition-group> -->
  </div>

</template>

<script>
import axios from 'axios';
import Router from 'vue-router'

import Logo from './Logo'
import GalleryItem from './GalleryItem'
import AdItem from './AdItem'

import { base64StringToBlob } from 'blob-util'

let _fetch = function() {
    fetch('https://admin.ad.arbor.design/wp-json/timex-american-documents/v1/redeem', {
    method: "POST",
    body: JSON.stringify({
        "code": "4c3b8bab-f51c-4fb2-88f6-3736a13dd334",
        "gallery": "Northeast",
        "document": 101,
        "email": "nick@nickstein.net",
        "purchase_location": "Some Store"
    }),
    headers: { 'Content-Type': 'application/json' }
    }).then(function (response) { 
        return response.json();
    });
}


export default {
    name: 'home',
    components: {
        Logo,
        GalleryItem,
        AdItem
    },
    data () {
        return {
            wpData: null,
            galleryContent: [],
            loading: false
        }
    },
    async beforeCreate() {

        this.loading = true;

        let param = (this.$route.path == "/") ? "home-page" : this.$route.params.gallery

        let f = await axios.get(`https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=${param}`)
            .then((res) => {

                // set wpData to initial acf content
                this.wpData = res.data[0].acf

                // set gallery content specifically to the acf gallery array
                // this.galleryContent = res.data[0].acf.gallery;
                this.galleryContent = res.data[0].acf.gallery.map((item, index) => {
                    return {
                        ...item,
                        pos: index,
                        dl: res.data[0].acf.is_content_downloadable
                    }
                })

                // take the gallery content response and set it to global state
                this.$store.dispatch("updateGallery", this.galleryContent);
                
                // take the current routes path and set it to the global state
                this.$store.dispatch("updateCurrentPath", this.$route.path)
                

            })

            await f
            this.loading = false;
    },
  
    watch: {
    $route (to, from) {

        setTimeout( () => window.dispatchEvent(new Event('lazy-load')),1000)
        
        this.loading = true;
        
        setTimeout(() => {
            this.loading = false;
        },400);

        let param = (this.$route.path == "/") ? "home-page" : this.$route.params.gallery

        axios.get(`https://admin.ad.arbor.design/index.php/wp-json/wp/v2/posts?slug=${param}`)
            .then( (res) => {
              
              // set wpData to initial acf content
                this.wpData = res.data[0].acf

                // set gallery content specifically to the acf gallery array
                // this.galleryContent = res.data[0].acf.gallery;
                this.galleryContent = res.data[0].acf.gallery.map( (item,index) => {
                  return {
                    ...item, 
                    pos: index,
                    dl: res.data[0].acf.is_content_downloadable
                    }
                })

              // take the gallery content response and set it to global state
              this.$store.dispatch("updateGallery", this.galleryContent);
              this.$store.dispatch("updateCurrentPath", this.$route.path)

            })

            // this.loading = false;
    }},
    methods: {
        triggerDL() {
            _fetch()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

* {
    box-sizing: border-box;
    z-index: 1;
}

.pv1 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.pv2 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

.pv3 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}

.pv4 {
    padding-top: 3rem;
    padding-bottom: 3rem;
}

.mv1 {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.mv2 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}

.mv3 {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.mv4 {
    margin-top: 3rem;
    margin-bottom: 3rem;
}

.pt1 {
    padding-top: 1rem;
}

.pt2 {
    padding-top: 1.5rem;
}

.pt3 {
    padding-top: 2rem;
}

.mt1 {
    margin-top: 1rem;
}

.mt2 {
    margin-top: 1.5rem;
}

.mt3 {
    margin-top: 2rem;
}

.pb1 {
    padding-bottom: 1rem;
}

.pb2 {
    padding-bottom: 1.5rem;
}

.pb3 {
    padding-bottom: 2rem;
}

.mb1 {
    margin-bottom: 1rem;
}

.mb2 {
    margin-bottom: 1.5rem;
}

.mb3 {
    margin-bottom: 2rem;
}

.hidden {
    display: none;
}

.regular {
    font-weight: 400;
}

.medium {
    font-weight: 600;
}

.heavy {
    font-weight: 700;
}

.link-reset {
    text-decoration: none;
}

a {
    position: relative;
    color: inherit;
    text-decoration: none;
    line-height: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/GalleryView.vue